<script setup lang="ts">
const packet = inject(keys.currentPacket);
</script>

<template>
  <!-- FIXME: Denne må ha padding i y-retning -->
  <Content
    is="section"
    v-if="packet?.relatedCta"
    class="flex flex-col gap-l"
  >
    <PacketRelatedCta
      v-if="packet.relatedCta?.card?.link?.href"
      :text="packet.relatedCta.card.title ?? ''"
      :link-to="packet.relatedCta.card.link.href"
      :link-label="packet.relatedCta.card.link.label ?? ''"
    />
    <div v-if="packet.relatedCta.products.length > 0" class="flex flex-col gap-m">
      <h3
        v-if="packet.relatedCta.title"
        class="text-base-versal uppercase text-white"
        v-text="packet.relatedCta.title"
      />

      <ul class="grid grid-cols-1 gap-l xs:grid-cols-3">
        <li v-for="product in packet.relatedCta.products" :key="product.id">
          <CardsRelated :product="toProductCard(product)" />
        </li>
      </ul>
    </div>
  </Content>
</template>
